<template>
  <div class="tw:w-auto tw:px-4 tw:mx-auto tw:mt-[40px] tw:md:max-w-[650px] tw:lg:max-w-none tw:mb-[60px] tw:md:my-[40px] tw:lg:my-[24px]">
    <h1 class="tw:font-bold tw:text-2xl tw:mx-auto tw:text-center">
      {{ $t('rc_setup_commission_header') }}
    </h1>

    <div class="tw:flex tw:justify-center">
      <ul class="tw:md:m-6 tw:md:mr-0 tw:my-6 tw:list-disc tw:pl-6" aria-label="Commission benefits">
        <li
          class="commission-benefits tw:mx-auto"
          v-for="(benefit, index) in benefits"
          :key="index"
          v-html="$t(benefit)"
        />
      </ul>
    </div>

    <fieldset class="tw:border-0 tw:p-0 tw:m-0 tw:lg:w-fit tw:md:max-w-[500px] tw:lg:max-w-none tw:md:mx-auto tw:w-full">
      <legend class="tw:sr-only">
        {{ $t('rc_setup_commission_select_level') }}
      </legend>

      <div class="tw:flex tw:flex-col tw:lg:flex-row tw:gap-4" role="radiogroup" :aria-label="$t('rc_setup_commission_select_level')">
        <label
          v-for="commissionLevel in eligibleCommissionLevels"
          :key="`level_${commissionLevel}`"
          :for="`commission-${commissionLevel}`"
          :data-testid="`commission-level-card-${commissionLevel}`"
          class="tw:py-3 tw:px-6 tw:lg:py-10 tw:shadow-lg tw:rounded-xl tw:cursor-pointer tw:transition-all tw:hover:bg-blue-100 tw:flex-1 tw:w-full tw:min-w-[140px] tw:lg:h-[200px] tw:lg:flex tw:lg:items-center tw:lg:justify-start"
          :class="
            selectedCommissionLevel === commissionLevel
              ? 'tw:border-2 tw:border-blue-700 tw:bg-blue-100'
              : 'tw:bg-white tw:border-2 tw:border-transparent hover:tw:border-blue-300'
          "
        >
          <div class="tw:flex tw:items-center tw:w-full tw:gap-8 tw:lg:gap-0 tw:lg:flex-col tw:lg:justify-between tw:lg:text-center tw:lg:h-full">
            <input
              type="radio"
              :value="commissionLevel"
              :id="`commission-${commissionLevel}`"
              :name="'commission-level'"
              :checked="selectedCommissionLevel === commissionLevel"
              @change="updateCommissionLevel(commissionLevel)"
              class="tw:cursor-pointer"
              :data-testid="`level_${commissionLevel}`"
              :aria-checked="selectedCommissionLevel === commissionLevel"
            />
            <div class="tw:w-full tw:lg:w-auto tw:text-[32px] tw:leading-[40px] tw:font-bold tw:lg:text-center tw:lg:mt-auto">
              {{ formatPercentage(language, commissionLevel, 0, 0) }}
              <span class="tw:sr-only">{{ $t('rc_commission_rate') }}</span>
            </div>
          </div>
        </label>
      </div>
    </fieldset>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

import { useCommissionLevels } from '../queries'
import { formatPercentage } from '@/utils/Utility.ts'
import { useSetup } from './useSetup'
import { useSessionValues } from '@/composables/useSessionValues'

const { language } = useSessionValues()
const { eligibleCommissionLevels } = useCommissionLevels()
const { selectedCommissionLevel, updateCommissionLevel } = useSetup()

const benefits = ['rc_commission_page_benefit_1', 'rc_commission_page_benefit_2', 'rc_commission_page_benefit_3']

onMounted(() => {
  updateCommissionLevel(18)
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant',
  })
})
</script>

<style scoped>
/* Screen reader only class */
.tw\:sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.commission-benefits :deep(ul) {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  list-style-type: disc;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
</style>
